import React from 'react';
import {Route, Routes} from 'react-router-dom';
import NavLink from './../../../../common/nav_link'
import SmsRateList from './list'

export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: '', name: 'Rate Tables'},
                {type: 'route', url: 'upload', name: 'Upload Rate'}
            ],
            data: {data:[], metadata: []}
        }
    }
    // componentDidMount() {
    //     this.loadFromServer();
    // }
    // loadFromServer() {
    //     const url = `/admin/products/sms/rates`;
    //     this.props.childProps.dataProvider.getList(url, {}).then(
    //         response => 
    //         this.setState({
    //             loading: false,
    //             data: response.data
    //         })
    //     );
    // }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, index) {
                                return (
                                    <NavLink
                                        key={ index }
                                        to={`/admin/products/smsrates/${ row.url }`}
                                        default={`/admin/products/smsrates`}
                                    >
                                        {/* { row.name } */}
                                    </NavLink>
                                )
                            }, this)}
                        </ul>
                    </div>
                </div>
                <Routes>
                    <Route index element={<SmsRateList routes={this.props.routes} childProps={this.props.childProps} parent={this.state.data}/>} />
                    {this.props.routes.map((route, i) => (
                        <Route key={i} path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps} parent={this.state.data}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
};
